<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'global-dashboard-page'}">{{ $t('adminDashboardPage.cards.globals') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'admin-organizations'}">{{ $t('adminDashboardPage.cards.organizations') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'admin-users'}">{{ $t('adminDashboardPage.cards.users') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'admin-units'}">{{ $t('adminDashboardPage.cards.departments') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'admin-mails'}">{{ $t('adminDashboardPage.cards.mails') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'admin-template'}">{{ $t('adminDashboardPage.cards.templateManagement') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'admin-statistics-dashboard-page'}">{{ $t('adminDashboardPage.cards.statistics') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";

export default {
  name: "AdminDashboardPage",
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.$t('adminDashboardPage.pageTitle'))
  }
}
</script>

<style scoped>

</style>